export const NumVisitors = {
  PRIVATE_TOUR: 1,
  UP_TO_TEN: 2,
  UP_TO_TWENTY: 3,
  UP_TO_FIFTY: 4,
  FIFTY_PLUS: 5,
};

export const TourTravelers = {
  ADULT: 1,
  CHILD: 2,
  INFANT: 3,
};

export const DraftSteps = {
  1: 'activity',
  2: 'about',
  3: 'features',
  4: 'photos',
  5: 'location',
  6: 'schedule-and-price',
  7: 'languages',
  8: 'whats-included',
  9: 'animals-to-see',
  10: 'cancellation',
  11: 'commissions',
  12: 'preview',
};
